import { render, staticRenderFns } from "./Consultative.vue?vue&type=template&id=54a9c76c&scoped=true&"
import script from "./Consultative.vue?vue&type=script&lang=js&"
export * from "./Consultative.vue?vue&type=script&lang=js&"
import style0 from "./Consultative.vue?vue&type=style&index=0&id=54a9c76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a9c76c",
  null
  
)

export default component.exports